<template>
  <component
    :is="group ? TransitionGroup : Transition"
    enter-active-class="transition duration-300 ease-in-out"
    leave-active-class="transition duration-300 ease-in-out"
    :enter-from-class="`opacity-0 ${enterFrom}`"
    :enter-to-class="`opacity-100 ${enterTo}`"
    :leave-from-class="`opacity-100 ${leaveFrom}`"
    :leave-to-class="`opacity-0 ${leaveTo}`"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { Transition, TransitionGroup } from 'vue';

import type { SlideProps } from '~/components/transitions/types';

let enterFrom = '';
let enterTo = '';
let leaveFrom = '';
let leaveTo = '';

const props = withDefaults(defineProps<SlideProps>(), { group: false });

onBeforeMount(() => {
  switch (props.direction) {
    case 'bottom':
      enterFrom = '-translate-y-10';
      enterTo = 'translate-y-0';
      leaveFrom = 'translate-y-0';
      leaveTo = '-translate-y-10';
      break;
    case 'left':
      enterFrom = 'translate-x-10';
      enterTo = '-translate-x-0';
      leaveFrom = '-translate-x-0';
      leaveTo = 'translate-x-10';
      break;
    case 'right':
      enterFrom = '-translate-x-10';
      enterTo = 'translate-x-0';
      leaveFrom = 'translate-x-0';
      leaveTo = '-translate-x-10';
      break;
    case 'top':
      enterFrom = 'translate-y-10';
      enterTo = 'translate-y-0';
      leaveFrom = 'translate-y-0';
      leaveTo = 'translate-y-10';
      break;
  }
});
</script>
